import 'style-loader!./slide3.component.scss';
import { Component, OnInit, ViewEncapsulation, Output, EventEmitter } from '@angular/core';
import { Status, IKeyboard, User, Copy } from 'app/theme/models/user.model';
import { AlertService } from 'app/theme/services/alert.service';
import { UserService } from 'app/theme/services/user.service';
import { ChannelService } from 'app/theme/services/channel.service';
import { IIsExistedResponse } from 'app/theme/models/response';
import { LanguageService } from 'app/theme/services/language.service';
import { MatIconRegistry } from '@angular/material';
import { DomSanitizer } from '@angular/platform-browser';
import { EmailService } from 'app/theme/services/email.service';
import { passwordStrength } from 'check-password-strength'
import { ElementRef, ViewChild } from '@angular/core';


@Component({
	selector: 'reg-slide3',
	templateUrl: './slide3.component.html',
	encapsulation: ViewEncapsulation.None

})
export class CreateBennetAccountComponent implements OnInit {
	user: User;
	@Output() createdAccount: EventEmitter<boolean> = new EventEmitter<boolean>()
	nonObbligatorio: boolean;
	Labels: any;
	alerts: any
	PassLength = new RegExp(/(.){8,}/);
	//emaiRegx = new RegExp(/^([a-zA-Z][a-zA-Z0-9_\.]+)@([a-zA-Z0-9_\.]+)\.([a-zA-Z]{2,5})$/m);
	emaiRegx = new RegExp(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/m);
	colorPassLength: string;
    colorPassUpper: string;
    colorPassLower: string;
    colorPassNum: string;
    colorPassSym: string;
	cofirmpassword: string;
	password: string;
	Matched: boolean;
	validPassword: boolean;
	noEmail: boolean;
	dontCreateAcount: boolean
	emailCREATED: boolean
	initEmail: string
	initEmailStatus: Status;
	constructor(
		protected _alertService: AlertService,
		protected _userService: UserService,
		protected _channelService: ChannelService,
		protected _langService: LanguageService,
		protected _emailService: EmailService,
		iconReg: MatIconRegistry,
		sanitizer: DomSanitizer,
	) {
		iconReg.addSvgIcon("info", sanitizer.bypassSecurityTrustResourceUrl('./assets/icon/icon_info.svg'))
	}


/**
 * 
 */
@ViewChild('mainContent') mainContent: ElementRef | null = null;
skipToMain(event: Event) {
	event.preventDefault(); // Evita il comportamento predefinito del link
	
	if (this.mainContent) {
	  setTimeout(() => {
		this.mainContent.nativeElement.focus();
	  }, 0); // Timeout per garantire che Angular abbia reso l'elemento visibile
	}
  }
//

	ngOnInit() {
		this.createdAccount.emit(true)
		this.nonObbligatorio = true;
		this.dontCreateAcount = false;
		this.Matched = false;
		this.validPassword = false;
		this.noEmail = true;
		this.password = "";
		this._userService.getUser().
			subscribe((user) => {
				if (user) {
					this.user = Copy(user);
					this.initEmail = user.contacts.email;
					if (!this.dontCreateAcount) 
						this.user.account.email = this.initEmail ? this.initEmail : user.account.email;
					if (this.user.info.canale == "totem" || this.user.info.canale == "totem-new" )
						this.createKeyboard();
						//console.log("createKeyboard")
				}
			})
		this._channelService.getSource().subscribe((source) => {
			if (source == "drive" || source == "bennet" || source == "drive-new" || source == "bennet-new" || source == "veronesi" || source == "app" || source=='instacook') {
				this.nonObbligatorio = false;
			}
		})
		this._langService.translatePageIndex(6).subscribe((mylabels) => {
			this.Labels = mylabels;
		})
		this._langService.subscribeAlerts().subscribe((alerts) => {
			if (alerts) {
				this.alerts = alerts;
			}
		})
	}

	openDialog() {
		this._alertService.showModalAlertInfo(this.Labels.question, `
		<p class="text-muted pl-1"> ${this.Labels.list} :</p>  <br>
		<ul class="text-left">
			<li>${this.Labels.l1} </li>
			<li>${this.Labels.l2} </li>
			<li>${this.Labels.l3} </li>
			<li>${this.Labels.l4} </li>
			<li>${this.Labels.l5} </li>
			<li>${this.Labels.l6} </li>
		</ul>
	 	`, null, "X");
	}
	openDialogrRulePwd() {
		this._alertService.showModalAlertInfo(this.Labels.rule, `
 		<ul class="text-left">
			<li>${this.Labels.r1} </li>
			<li>${this.Labels.r2} </li>
			<li>${this.Labels.r3} </li>
			<li>${this.Labels.r4} </li>
			<li>${this.Labels.r5} </li>
		</ul>
	 	`, null, "X");
	}
	createKeyboard() {
		if (this.user.info.canale == "totem" || this.user.info.canale == "totem-new") {
			require.ensure(['app/theme/assets/scripts/VirtualKeyboard.js'], require => {
				var virtualKeyboard = require('app/theme/assets/scripts/VirtualKeyboard.js');
				var keyboard1: IKeyboard = { options: {}, target: null, container: ".PageSlide3" };
				let vk = new virtualKeyboard.default(keyboard1);
				vk.init(".PageSlide3");
			});
		}
	}
	validatePassword() {
		var pwd = this.password;
		var passContains:string[]=passwordStrength(pwd).contains;
		let result = passwordStrength(pwd).id;  
        $("#password-strength").removeClass().addClass("strength-" + result);
		this.colorPassLength = this.PassLength.test(pwd) ? "green" : "red";
		this.colorPassUpper = passContains.indexOf('uppercase') != -1? "green" : "red";
        this.colorPassLower = passContains.indexOf('lowercase') != -1 ? "green" : "red";
		this.colorPassNum = passContains.indexOf('number') != -1 ? "green" : "red";
		this.colorPassSym = passContains.indexOf('symbol') != -1? "green" : "red"; 
		this.validPassword =  this.PassLength.test(pwd) && (passContains.indexOf('uppercase') != -1) && (passContains.indexOf('lowercase') != -1) && (passContains.indexOf('number') != -1)  && (passContains.indexOf('symbol') != -1);

		this.cofirmpassword = "";
	}
	dontCreateAccount() {
		this.user.account.email = this.dontCreateAcount ? '' : (this.initEmail ? this.initEmail : this.user.account.email);
		this.user.account.password = "";
		this.createdAccount.emit(!this.dontCreateAcount)
	}
	isMatched() {
		return this.Matched = this.cofirmpassword === this.password;
	}

	isValidEmail() {
		var email = this.user.account.email.trim();
		return this.emaiRegx.test(email);
	}
	replaceWith(content: string, repacedWith: string): string {
		return content.replace("XXXX", repacedWith);
	}

	onSubmitBennetAccountORonSkip(): Promise<any> {
		return new Promise((resolve, reject) => {
			if (this.dontCreateAcount) {
				this.user.account.registrato = false;
				this.user.account.emailStatus = Status.NONE;
				this.user.account.email = "";
				this.user.account.password = "";
				this._userService.setUser(this.user);
				resolve();
			}
			else {
				if (!this.validPassword)
					reject({ title: this.Labels.rule, content: this.alerts.alert_13, btn: this.Labels.cancel });
				else if (!this.isMatched())
					reject({ title: "", content: this.alerts.alert_14, btn: this.Labels.cancel });
				else if (!this.isValidEmail())
					reject({ title: "", content: this.replaceWith(this.alerts.alert_4, this.user.account.email), btn: this.Labels.cancel });
				else {
					if (!this.initEmail) {
						this._emailService.FindEmail(this._userService.customerid,this.user.account.email)
							.then((res: IIsExistedResponse) => {
								if (res.exist) {
									reject({ title: "", content: this.replaceWith(this.alerts.alert_3, this.user.account.email), btn: this.Labels.cancel })
								}
								else
									this._emailService.VerifyEmail(this.user.account.email)
										.then((data: IIsExistedResponse) => {
											if (data.exist)
												this.user.account.emailStatus = Status.Verified;
											else {
												this.user.account.emailStatus = Status.Invalid;
												reject({ title: this.Labels.invalid, content: this.replaceWith(this.alerts.alert_7, this.user.account.email), btn: this.Labels.cancel })
											}
										})
										.catch((error) => {
											this.user.account.emailStatus = Status.Unchecked;
											resolve();
										})
							})
							.catch((error) => {
								if(this.user.info.canale=='app'){
									//console.log("chiamata script KO FindEmail");
									self.postMessage(JSON.stringify({"type": "KO", payload: {"username": "", "password": "", "message":this.alerts.alert_32}}),'*');
								}
								reject({ title: "SERVER", content: this.alerts.alert_32 });
							})
					}
					this.user.account.registrato = true;
					this.user.account.password = this.password;
					this._userService.setUser(this.user);
					resolve();
				}
			}
		})
	}
}


// WEBPACK FOOTER //
// ./src/app/theme/components/slide3/slide3.component.ts